// extracted by mini-css-extract-plugin
module.exports = {"docPosition768_max":"docPosition768_max___3YwuG","docPosition768Max":"docPosition768_max___3YwuG"};